module.exports = __webpack_public_path__ + "static/img/qsc.8a1fb48.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/function/qsc.gif
// module id = 3/Nw
// module chunks = 1